import React, { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import CommonFooter from "../../core/common/footer/commonFooter";
import TooltipIcons from "../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
// import AddPurchases from "../../core/modals/purchases/addPurchases";
import { 
  useDeletePurchaseOrderMutation, 
  useGetPurchaseOrderByIdQuery, 
  useGetPurchaseOrdersQuery,
  useUpdatePurchaseOrderMutation 
} from "../../core/redux/api/OrderApi";
import CommonDeleteModal from "../../core/common/modal/commonDeleteModal";
import toast from "react-hot-toast";
import { DatePicker } from "antd";

import { useGetProductListQuery } from "../../core/redux/api/productApi";
import { useGetAllSupplierQuery } from "../../core/redux/api/userApi";
import AddPurchases from "../../core/modals/purchases/addpurchases";
import EditPurchasesOrder from "../../core/modals/purchases/editPurchases";

const PurchasesList = () => {
  const { data: todayPurchaseOrder, isLoading: isTodayPurchaseOrderLoading, refetch: refetchTodayPurchaseOrders } = useGetPurchaseOrdersQuery();
  const [deletePurchase] = useDeletePurchaseOrderMutation();
  const [updatePurchase, { isLoading: isUpdating }] = useUpdatePurchaseOrderMutation();
  const { data: productResponse } = useGetProductListQuery();
  const { data: supplierResponse } = useGetAllSupplierQuery();
  
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [purchaseOrderToDelete, setPurchaseOrderToDelete] = useState(null);
  const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const { data: purchaseOrderData, isLoading: isPurchaseOrderLoading } = useGetPurchaseOrderByIdQuery(selectedPurchaseOrderId, {
    skip: !selectedPurchaseOrderId,
  });

  const handleDelete = async () => {
    if (!purchaseOrderToDelete) return;

    try {
      await toast.promise(
        deletePurchase(purchaseOrderToDelete).unwrap(),
        {
          loading: 'Deleting order...',
          success: async () => {
            await refetchTodayPurchaseOrders();
            setShowDeleteModal(false);
            setPurchaseOrderToDelete(null);
            return 'Order deleted successfully!';
          },
          error: (err) => {
            if (err.status === 404) {
              refetchTodayPurchaseOrders();
              return 'Order was already removed';
            }
            return err.data?.message || 'Delete failed';
          }
        }
      );
    } catch (error) {
      console.error("Delete error:", error);
      const message = error?.data?.message || 'Delete failed';
      if (!message.includes("already deleted")) {
        toast.error(message);
      }
    }
  };

  const handleEdit = (record) => {
    setSelectedPurchaseOrderId(record._id);
    setShowEditModal(true);
  };

  const handleUpdatePurchasesOrder = async (values) => {
    try {
      await toast.promise(
        updatePurchase({
          _id: selectedPurchaseOrderId,
          ...values
        }).unwrap(),
        {
          loading: 'Updating order...',
          success: async () => {
            await refetchTodayPurchaseOrders();
            setShowEditModal(false);
            setSelectedPurchaseOrderId(null);
            return 'Order updated successfully!';
          },
          error: (err) => {
            return err.data?.message || 'Update failed';
          }
        }
      );
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error?.data?.message || 'Update failed');
    }
  };

  const columns = [
    {
      title: "Supplier Name",
      dataIndex: "supplier",
      render: (supplier) => <span>{supplier?.supplierName}</span>,
      sorter: (a, b) => a.supplier?.supplierName.length - b.supplier?.supplierName.length,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Product Name",
      dataIndex: "product",
      render: (product) => <span>{product?.productName}</span>,
      sorter: (a, b) => a.product?.productName.length - b.product?.productName.length,
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Unit",
      dataIndex: "unit",
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Purchase Rate",
      dataIndex: "purchaseRate",
      sorter: (a, b) => a.purchaseRate - b.purchaseRate,
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Note",
      dataIndex: "note",
      render: (text) => text || "-",
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Amount",
      dataIndex: "totalAmount",
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleEdit(record);
              }}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link
              to="#"
              className="p-2"
                 data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={(e) => {
                e.preventDefault();
                setPurchaseOrderToDelete(record._id);
      
              }}
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
  ];

  const expandable = {
    expandedRowRender: (record) => (
      <div>
        <p><strong>Quantity:</strong> {record.quantity}</p>
        <p><strong>Unit:</strong> {record.unit}</p>
        <p><strong>Purchase Rate:</strong> {record.purchaseRate}</p>
        <p><strong>Note:</strong> {record.note || "-"}</p>
        <p><strong>Amount:</strong> {record.totalAmount}</p>
      </div>
    ),
    rowExpandable: () => true,
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Purchases</h4>
                <h6>Manage Your Purchase Order</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <i className='ti ti-circle-plus me-1'></i>
                Add Purchases
              </Link>
            </div>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Payment Status
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li><Link to="#" className="dropdown-item rounded-1">Paid</Link></li>
                    <li><Link to="#" className="dropdown-item rounded-1">Unpaid</Link></li>
                    <li><Link to="#" className="dropdown-item rounded-1">Overdue</Link></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <Table 
                  columns={columns} 
                  dataSource={todayPurchaseOrder} 
                  expandable={expandable} 
                  loading={isTodayPurchaseOrderLoading}
                />
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      <AddPurchases 
        productResponse={productResponse}
        supplierResponse={supplierResponse}
      />
    
      {showEditModal && (
        <EditPurchasesOrder
          purchasesOrder={purchaseOrderData}
          productlist={productResponse?.data}
          suppliersList={supplierResponse}
          onUpdate={handleUpdatePurchasesOrder}
          onCancel={() => {
            setShowEditModal(false);
            setSelectedPurchaseOrderId(null);
          }}
          isUpdating={isUpdating}
          isLoading={isPurchaseOrderLoading}
        />
      )}

      <CommonDeleteModal 
      handleDelete={handleDelete}
         />
    </div>
  );
};

export default PurchasesList;